import React, {useEffect} from 'react'
import Arrow from './Arrow'
import ImageSlide from './ImageSlide';
import Pagination from './Pagination'
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentImageIndex } from 'actions/carouselActions';

const CarouselContainer = ({images, hasArrow, width, height, paginationPosition}) => {

	const dispatch = useDispatch();
	const currentImageIndex = useSelector(state => state.carousel.currentImageIndex);
	const previousSlide = () => {
		const lastIndex = images.length - 1;
		const shouldResetIndex = currentImageIndex === 0;
		const index = shouldResetIndex ? lastIndex : currentImageIndex - 1;
		dispatch(setCurrentImageIndex(index));
	};

	const nextSlide = () => {
		const lastIndex = images.length - 1;
		const shouldResetIndex = currentImageIndex === lastIndex;
		const index = shouldResetIndex ? 0 : currentImageIndex + 1;
		dispatch(setCurrentImageIndex(index));
	};

	const paginateCurrentIndex = (idx) => {
		dispatch(setCurrentImageIndex(idx));
	};

	useEffect(() => {
		const interval = setInterval(nextSlide, 10000);

		return () => clearTimeout(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
	  }, [currentImageIndex])

	return (
		<div>
			{images.length > 1 ? (
				<div className="carousel">
					<ImageSlide url={images[currentImageIndex]} width={width} height={height} />
					{hasArrow && (
						<div>
							<Arrow direction="left" clickFunction={ previousSlide } glyph="&#9664;" />
							<Arrow direction="right" clickFunction={ nextSlide } glyph="&#9654;" />
						</div	>
					)}
					<div className='paginationContainer' style={paginationPosition}>
						{images.map((v, index) => {
							let selected = true;
							if (currentImageIndex ===  index) {
							selected = false;
							}
								return (
									<Pagination
										key={index}nextSlide
										selected={selected}
										clickFunction={() => paginateCurrentIndex(index)}
									/>
								);
						})}
					</div>
				</div>
			): (
				<ImageSlide url={images[currentImageIndex]} width={width} height={height}/>
			)}

		</div>
	);
}

export default CarouselContainer



// WEBPACK FOOTER //
// ./components/common/global-carousel/CarouselContainer.js